export enum Experiment {
  UseLocalizationService = 'specs.myAccount.UseLocalizationService',
  EnableGeneralSettings = 'specs.membersArea.generalSettingsViewer',
  UseNewPrivacyModalContent = 'specs.myAccount.UseNewPrivacyModalContent',
}
